import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import './Login.scss';
import logo from '../../assets/img/SUMATELLEVA_BCO.png'
import IDLogo from '../../assets/img/LOGO_ID_BLANCO_NARANJA.png';
import { peticionLogin } from "./integracion";
import { Link, useNavigate } from "react-router-dom";

// Paleta de colores extraída de la imagen
const colors = {
    orange: '#07243b',
    lightOrange: '#0b7ad1',
    darkBlue: '#2c3e50',
    lightBlue: '#f5f7fa',
    white: '#ffffff',
    gray: '#95a5a6',
    darkGray: '#333333'
};

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Detectar tamaño de pantalla para ajuste responsivo
    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        // Verificar tamaño inicial
        checkScreenSize();

        // Agregar event listener para cambios de tamaño
        window.addEventListener('resize', checkScreenSize);

        // Cleanup
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        const login = async () => {
            await peticionLogin(email, password, navigate);
        }
        await login().then(r => setLoading(false));
    };

    return (
        <div style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            minHeight: '100vh',
            width: '100%',
            backgroundColor: colors.lightBlue
        }}>
            {/* Left side - App information */}
            <div style={{
                flex: isMobile ? 'none' : '1',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                background: `linear-gradient(135deg, ${colors.orange}, ${colors.lightOrange})`,
                color: colors.white,
                padding: isMobile ? '2rem 1rem' : '2rem 3rem',
                position: 'relative',
                overflow: 'hidden',
                minHeight: isMobile ? 'auto' : '100vh',
                boxShadow: '0 0 20px rgba(0, 0, 0, 0.1)'
            }}>
                {/* Decorative elements */}
                <div style={{
                    position: 'absolute',
                    width: '300px',
                    height: '300px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    top: '-100px',
                    left: '-100px',
                    zIndex: 0
                }}></div>
                <div style={{
                    position: 'absolute',
                    width: '200px',
                    height: '200px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    bottom: '50px',
                    right: '-50px',
                    zIndex: 0
                }}></div>
                <div style={{
                    position: 'absolute',
                    width: '150px',
                    height: '150px',
                    borderRadius: '50%',
                    backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    top: '30%',
                    right: '15%',
                    zIndex: 0
                }}></div>

                {/* Suma Logo in top left */}
                <div style={{
                    position: 'absolute',
                    top: '20px',
                    left: '20px',
                    zIndex: 5
                }}>
                    <img src={logo} alt="logo-suma" style={{
                        width: isMobile ? '100px' : '150px'
                    }} />
                </div>

                {/* I+D Logo */}
                <div style={{
                    zIndex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginBottom: '2rem',
                    marginTop: isMobile ? '4rem' : '0'
                }}>
                    <div style={{
                        width: isMobile ? '100px' : '140px',
                        height: isMobile ? '100px' : '140px',
                        borderRadius: '50%',
                        backgroundColor: colors.darkBlue,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: '2rem',
                        boxShadow: '0 8px 30px rgba(0, 0, 0, 0.3)',
                        border: '5px solid rgba(255, 255, 255, 0.2)'
                    }}>
                        <img src={IDLogo} alt="logo-I+D" style={{
                            width: isMobile ? '70px' : '100px'
                        }} />
                    </div>
                </div>

                <div style={{ zIndex: 1, maxWidth: '600px', textAlign: isMobile ? 'center' : 'left' }}>
                    <h1 style={{
                        fontSize: isMobile ? '2.5rem' : '3.5rem',
                        marginBottom: '1rem',
                        fontWeight: '700',
                        textShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)'
                    }}>Portal Suma</h1>

                    <h2 style={{
                        fontSize: isMobile ? '1.4rem' : '1.8rem',
                        marginBottom: '1.5rem',
                        fontWeight: '400',
                        letterSpacing: '1px'
                    }}>Plataforma de Gestión administrativa</h2>

                    <Divider style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.3)',
                        margin: '1.5rem 0',
                        width: isMobile ? '80%' : '60%'
                    }} />

                    {!isMobile && (
                        <p style={{
                            fontSize: '1.1rem',
                            lineHeight: '1.8',
                            marginBottom: '2.5rem',
                            textShadow: '1px 1px 2px rgba(0, 0, 0, 0.1)'
                        }}>
                            Este sitio web es una plataforma integral diseñada para la gestión operativa, administrativa
                            y de talento humano de Suma. Su objetivo principal es centralizar y optimizar
                            los procesos internos, brindando a cada área las herramientas necesarias para llevar un
                            control eficiente, tomar decisiones informadas y mejorar la productividad.
                        </p>
                    )}
                </div>
            </div>

            {/* Lado derecho - Formulario de login */}
            <div style={{
                flex: isMobile ? 'none' : '1',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: isMobile ? '1.5rem 1rem' : '2rem',
                backgroundColor: colors.white
            }}>
                <Card style={{
                    width: '100%',
                    maxWidth: isMobile ? '100%' : '450px',
                    borderRadius: '12px',
                    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
                    border: `1px solid ${colors.lightBlue}`
                }}>
                    <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
                        <h2 style={{ fontSize: '1.75rem', color: colors.darkBlue }}>Iniciar Sesión</h2>
                        <p style={{ color: colors.slate }}>Ingresa tus credenciales para acceder</p>
                    </div>

                    <form onSubmit={handleLogin}>
                        <div style={{ marginBottom: '1.5rem' }}>
                            <label htmlFor="email" style={{
                                display: 'block',
                                marginBottom: '0.5rem',
                                fontWeight: '500',
                                color: colors.darkBlue
                            }}>
                                Correo electrónico
                            </label>
                            <div className="p-inputgroup">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-envelope" style={{ color: colors.orange }}></i>
                                </span>
                                <InputText
                                    id="email"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="ejemplo@suma.mx"
                                    style={{
                                        width: '100%',
                                        padding: '0.75rem',
                                        fontSize: '1rem',
                                        borderTopRightRadius: '8px',
                                        borderBottomRightRadius: '8px'
                                    }}
                                    required
                                />
                            </div>
                        </div>

                        {/* <div style={{ marginBottom: '1.5rem' }}>
                            <label htmlFor="password" style={{
                                display: 'block',
                                marginBottom: '0.5rem',
                                fontWeight: '500',
                                color: colors.darkBlue
                            }}>
                                Contraseña
                            </label>
                            <div className="p-inputgroup">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-lock" style={{ color: colors.orange }}></i>
                                </span>
                                <Password
                                    id="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Ingresa tu contraseña"
                                    toggleMask
                                    feedback={false}
                                    style={{ width: '100%' }}
                                    inputStyle={{
                                        width: isMobile? '100%' : '22.5rem',
                                        padding: '0.75rem',
                                        fontSize: '1rem',
                                        borderTopRightRadius: '8px',
                                        borderBottomRightRadius: '8px',
                                        borderTopLeftRadius: '0px',
                                        borderBottomLeftRadius: '0px'
                                    }}
                                    required
                                />
                            </div>
                        </div> */}
                        <div style={{ marginBottom: '1.5rem' }} className="pass-form">
                            <label htmlFor="password" style={{
                                display: 'block',
                                marginBottom: '0.5rem',
                                fontWeight: '500',
                                color: colors.darkBlue
                            }}>
                                Contraseña
                            </label>
                            <div className="p-inputgroup">
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-lock" style={{ color: colors.orange }}></i>
                                </span>
                                <Password
                                    id="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Ingresa tu contraseña"
                                    toggleMask
                                    feedback={false}
                                    style={{ width: '100%' }}
                                    inputStyle={{
                                        padding: '0.75rem',
                                        fontSize: '1rem',
                                        borderTopRightRadius: '8px',
                                        borderBottomRightRadius: '8px',
                                        borderTopLeftRadius: '0px',
                                        borderBottomLeftRadius: '0px'
                                    }}
                                    required
                                />
                            </div>
                        </div>


                        <div style={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            justifyContent: 'space-between',
                            alignItems: isMobile ? 'flex-start' : 'center',
                            marginBottom: '1.5rem',
                            gap: isMobile ? '1rem' : '0'
                        }}>

                            <Link to="/recovery" style={{
                                color: colors.orange,
                                textDecoration: 'none',
                                fontWeight: '500'
                            }}>
                                ¿Olvidaste tu contraseña?
                            </Link>
                        </div>

                        <Button
                            type="submit"
                            label="Iniciar Sesión"
                            icon="pi pi-sign-in"
                            loading={loading}
                            style={{
                                width: '100%',
                                backgroundColor: colors.darkBlue,
                                border: 'none'
                            }}
                        />
                    </form>
                </Card>
            </div>
        </div>
    );
};

export default Login;